import React, { useContext } from "react";
import { ConfirmDialog, ConfirmDialogTemplateType } from "primereact/confirmdialog";
import { AppContext } from "../../context/index";

export interface NewDialogProps {
  title?: React.ReactNode;
  visible: boolean;
  setVisible?: React.Dispatch<React.SetStateAction<boolean>>;
  handleModalState? : React.Dispatch<React.SetStateAction<NewDialogProps>> 
  content?: ConfirmDialogTemplateType;
  acceptLabel?: string | undefined;
  rejectLabel?: string | undefined;
  onConfirm?: any;
  closable?: boolean;
  onReject?: any;
  aditionalClass?: string;
}

export const NewCustomDialog: React.FC<NewDialogProps> = ({
  title,
  visible,
  setVisible,
  handleModalState,
  content,
  acceptLabel,
  rejectLabel,
  onConfirm = () => {},
  closable = true,
  onReject = false,
  aditionalClass = '',
}) => {
  const { t } = useContext(AppContext);

  const onCloseModal = () => {
    if (setVisible) {
      setVisible(false);
    } else if (handleModalState) {
      handleModalState((prev: object) => ({
        ...prev,
        visible: false,
        onReject: false,
      }));
    }
  };

  return (
    <ConfirmDialog
      id='pr_id_1'
      className={`confirmdialog-cancel ${aditionalClass}`}
      visible={visible}
      header={title}
      onHide={!closable ? onCloseModal : (onReject || onCloseModal)}
      message={content}
      accept={onConfirm}
      reject={onReject || onCloseModal}
      acceptLabel={acceptLabel || t("Options.acceptOptionLabel")}
      rejectLabel={rejectLabel || t("Options.rejectOptionLabel")}
      closable={closable}
      rejectClassName={onReject==='close' ? 'inactivity-reject-button' : ''}
    />
  );
};
